import { Icon } from "@/assets/icons";
import { cn } from "@/utils";
import React from "react";

type Value = number | string | boolean;
type Option = {
  label: string;
  value: Value;
  disabled?: boolean;
};

type RadioGroupProps = {
  ref?: React.Ref<HTMLDivElement>;
  options: Option[];
  value?: Value;
  onChange?: (value: Value) => void;
  disabled?: boolean;
  label?: string;
  error?: string;
  required?: boolean;
};

const RadioGroup: React.FC<RadioGroupProps> = ({
  ref,
  options,
  value,
  onChange,
  disabled,
  label,
  error,
  required,
}) => {
  const handleClick = (option: Option) => {
    if (!option.disabled) {
      onChange?.(option.value);
    }
  };

  return (
    <div ref={ref} className="relative">
      {label && (
        <label
          className={`
                  absolute left-4 top-0 -translate-y-1/2 px-1 text-xs z-[2]
                  ${error ? "text-error_main" : "text-grey-600"}
                `}
          style={{
            background: disabled
              ? "linear-gradient(to bottom, transparent 50%, #F4F6F8 50%)"
              : "#ffffff",
          }}
        >
          {label}
          {required && <span className="text-error_main ml-1">*</span>}
        </label>
      )}

      <div className="flex items-center gap-4 flex-wrap">
        {options.map((option, index) => (
          <label
            key={`${index}-${option.value}`}
            onClick={() => handleClick(option)}
            className={cn(
              "flex items-center cursor-pointer text-sm text-light_primary",
              {
                "opacity-50 cursor-not-allowed": option.disabled || disabled,
              },
            )}
          >
            {option.value === value ? (
              <Icon name="radio" />
            ) : (
              <Icon name="radio-uncheck" />
            )}
            {option.label}
          </label>
        ))}
      </div>

      {error && <p className="text-error_main text-xs mt-1">{error}</p>}
    </div>
  );
};

export { RadioGroup };
